import * as React from 'react';
import './styles.scss';


export type ContentPanelProps = {
  panelStyle?: "celestial-blue" | "celestial-blue-5" | "white";
};

export const ContentPanel: React.FunctionComponent<ContentPanelProps> = ({ panelStyle, children }) => {
  return (
    <div className={`cmp-content-panel cmp-content-panel__${panelStyle ?? "celestial-blue"}`}>{children}</div>
  );
};
